import React, { createContext, useContext, useState, useCallback } from "react";
import {fetchCategoriesApi, addCategoryApi, updateCategoryApi, deleteCategoryApi} from "./api/api";
import { useAuthenticatedEffect } from "./components/useauthenticatedeffect";
// import {useAccounts} from "./contextjs/AccountContext";

const CategoryContext = createContext();

export const useCategories = () => useContext(CategoryContext);

export const CategoryProvider = ({children}) => {
    const [categories, setCategories] = useState([]);

    // useEffect(() => {
    //     const fetchCategories = async () => {
    //         try {
    //             const fetchedCategories = await fetchCategoriesApi();
    //             setCategories(fetchedCategories);
    //         } catch (error) {
    //             console.error('Error fetching categories from context:', error);
    //         }
    //     };
    //     fetchCategories();
    // }, []);

    const fetchCategories = useCallback(async () => {
        try {
            const fetchedCategories = await fetchCategoriesApi();
            setCategories(fetchedCategories);
        } catch (error) {
            console.error('Error fetching categories from context:', error);
        }
    }, []);

    useAuthenticatedEffect(
        useCallback(() => {
            fetchCategories().then(r => r); // added then(r => r) to remove warning
        }, [fetchCategories])
    );

    const addCategory = async (newCategory) => {
        try {
            const addedCategory = await addCategoryApi(newCategory);
            setCategories([...categories, addedCategory]);
        } catch (error) {
            console.error('Error adding category:', error);
        }
    };

    const updateCategory = async (updatedCategory) => {
        try {
            const updatedCategoryData = await updateCategoryApi(updatedCategory);
            setCategories((currentCategories) =>
                currentCategories.map((category) =>
                    category.id === updatedCategoryData.id ? updatedCategoryData : category));
        } catch (error) {
            console.error('Error updating category:', error);
        }
    };

    const deleteCategory = async (categoryId) => {
        try {
            await deleteCategoryApi(categoryId);
            setCategories(categories.filter(c => c.id !== categoryId));
        } catch (error) {
            console.error('Error deleting category:', error);
        }
    };

    return (
        <CategoryContext.Provider value={{
            categories,
            addCategory,
            updateCategory,
            deleteCategory,
            // editCategory,
            // setEditCategory
        }}>
            {children}
        </CategoryContext.Provider>
    );
};
